import { cn } from "@/lib/utils";

type ProcessStepProps = {
  code: string;
  title: string;
  description: string;
  marker?: string;
  dark?: boolean;
};

const ProcessStep = ({ code, title, description, marker, dark }: ProcessStepProps) => (
  <li
    className={cn(
      "relative grid grid-cols-[3rem_1fr] gap-x-5 border-b border-l-2 border-l-transparent py-7 pl-3 -ml-3 transition-colors duration-400 sm:grid-cols-[5rem_1fr_auto] md:py-9",
      dark ? "border-[hsl(var(--sd-fg)/0.08)] hover:border-l-primary/50" : "border-border/42 hover:border-l-primary/45",
    )}
  >
    <span className={cn("absolute left-0 top-8 h-2 w-2 border", dark ? "border-primary/45 bg-[hsl(var(--control-panel))]" : "border-primary/45 bg-background")} aria-hidden="true" />
    <span className={cn("font-mono text-[10px] tracking-[0.16em] pt-1", dark ? "text-[hsl(var(--sd-fg)/0.34)]" : "text-muted-foreground/82")}>
      {code}
    </span>
    <div className="min-w-0">
      <h3 className={cn("mb-2 text-[16px] font-semibold leading-snug", dark ? "text-[hsl(var(--sd-fg)/0.9)]" : "text-foreground")}>
        {title}
      </h3>
      <p className={cn("max-w-xl text-[14.5px] leading-[1.78]", dark ? "text-[hsl(var(--sd-fg)/0.56)]" : "text-muted-foreground")}>
        {description}
      </p>
    </div>
    {marker ? (
      <div className="hidden pt-1.5 sm:flex sm:items-start">
        <span className={cn("font-mono text-[9.5px] tracking-[0.16em] uppercase", dark ? "text-primary/65" : "text-primary/70")}>
          {marker}
        </span>
      </div>
    ) : null}
  </li>
);

export default ProcessStep;
